{
  "corporatePortal": {
    "home": {
      "widgetTitle": "Your company travels"
    }
  }
}
